export const INVOICE_SOURCE_SYNC_STATUS = {
  IN_SYNC: "IN_SYNC",
  CHANGED: "CHANGED",
  NEEDS_REVIEW: "NEEDS_REVIEW",
  VOIDED_SOURCE_DELETED: "VOIDED_SOURCE_DELETED",
  IGNORED: "IGNORED",
} as const;

// Statuses that still need someone to act on them
export const OUT_OF_SYNC_STATUSES = [
  INVOICE_SOURCE_SYNC_STATUS.CHANGED,
  INVOICE_SOURCE_SYNC_STATUS.NEEDS_REVIEW,
];

export const SOURCE_SYNC_FIELD = {
  AMOUNT: "amount",
  TAX_AMOUNT: "tax_amount",
  INVOICE_DATE: "invoice_date",
  DUE_DATE: "due_date",
  LINE_ITEMS: "line_items",
  VOIDED: "voided",
  DELETED: "deleted",
} as const;

export const SOURCE_SYNC_AMOUNT_FIELDS: string[] = [
  SOURCE_SYNC_FIELD.AMOUNT,
  SOURCE_SYNC_FIELD.TAX_AMOUNT,
];

export const SOURCE_SYNC_DATE_FIELDS: string[] = [
  SOURCE_SYNC_FIELD.INVOICE_DATE,
  SOURCE_SYNC_FIELD.DUE_DATE,
];

export const SOURCE_SYNC_TAG_LABEL = {
  [INVOICE_SOURCE_SYNC_STATUS.CHANGED]: "Changed at source",
  [INVOICE_SOURCE_SYNC_STATUS.NEEDS_REVIEW]: "Needs review",
  [INVOICE_SOURCE_SYNC_STATUS.VOIDED_SOURCE_DELETED]: "Voided at source",
} as const;

export const SOURCE_SYNC_PAGE_SIZE = 20;

export const RESYNC_LOCKED_TEXT =
  "This invoice is in a locked period, so it can't be updated. Update your lock date in Settings, then come back and re-sync.";
